import { render, staticRenderFns } from "./msw-signature-issues.vue?vue&type=template&id=0567e02a&scoped=true&"
import script from "./msw-signature-issues.vue?vue&type=script&lang=tsx&"
export * from "./msw-signature-issues.vue?vue&type=script&lang=tsx&"
import style0 from "./msw-signature-issues.vue?vue&type=style&index=0&id=0567e02a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0567e02a",
  null
  
)

export default component.exports